const MANUAL_CURRENCY_KEY = 'cadencez.currency.manual';

export function markManualCurrency(): void {
  try { localStorage.setItem(MANUAL_CURRENCY_KEY, '1'); } catch { /* private mode */ }
}

export function isManualCurrency(): boolean {
  try { return localStorage.getItem(MANUAL_CURRENCY_KEY) === '1'; } catch { return false; }
}
